module.exports = __webpack_public_path__ + "img/future.110a25a1.png";